import { axiosClient } from "../../../config/axios";

export const verifyMailApi = async (token) => {
	const res = await axiosClient(`/mail/verify/${token}`);
	return res;
};
